/**
 * AppError base class and error codes used across the application.
 */
export enum AppErrorCode {
  UNKNOWN = 'UNKNOWN',
  WORD_API_FAILED = 'WORD_API_FAILED',
  ELEMENT_INSERT_FAILED = 'ELEMENT_INSERT_FAILED',
  DUPLICATE_ELEMENT_ID = 'DUPLICATE_ELEMENT_ID',
  TEMPLATE_NOT_FOUND = 'TEMPLATE_NOT_FOUND',
  DUPLICATE_TEMPLATE_ID = 'DUPLICATE_TEMPLATE_ID',
  INVALID_LAYOUT_CONFIG = 'INVALID_LAYOUT_CONFIG',
}

/**
 * Base application error used by core modules.
 */
export class AppError extends Error {
  /** Error code categorizing the failure */
  public readonly code: AppErrorCode;

  /** Optional underlying cause */
  public readonly cause?: unknown;

  /**
   * Create a new AppError.
   * @param message human-friendly message
   * @param code categorized error code
   * @param cause optional underlying cause
   */
  constructor(message: string, code: AppErrorCode, cause?: unknown) {
    super(message);
    this.name = 'AppError';
    this.code = code;
    this.cause = cause;
    Object.setPrototypeOf(this, new.target.prototype);
  }

  /** Type guard to check if unknown value is an AppError */
  public static isAppError(e: unknown): e is AppError {
    return (
      typeof e === 'object' &&
      e !== null &&
      'code' in e &&
      (e as { code: unknown }).code !== undefined &&
      e instanceof AppError
    );
  }
}
